
<app-initialformmapa
	*ngIf="is(formsEnum.MAPA_IN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-initialformmapa>

<app-annulationformmapa
	*ngIf="is(formsEnum.MAPA_AN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-annulationformmapa>

<app-attributionformmapa
	*ngIf="is(formsEnum.MAPA_AT)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-attributionformmapa>

<app-formmapa-rectificatif
	*ngIf="is(formsEnum.MAPA_RE)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-formmapa-rectificatif>

<app-formfnsimple
	*ngIf="is(formsEnum.SIMP_IN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-formfnsimple>

<app-form-divers-initial
	*ngIf="is(formsEnum.DIVE_IN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-form-divers-initial>

<app-form-divers-attribution
	*ngIf="is(formsEnum.DIVE_AT)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-form-divers-attribution>

<app-form-divers-annulation
	*ngIf="is(formsEnum.DIVE_AN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-form-divers-annulation>

<app-form-divers-rectificatif
	*ngIf="is(formsEnum.DIVE_RE)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-form-divers-rectificatif>

<app-formfnsimple-rectificatif
	*ngIf="is(formsEnum.SIMP_RE)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

>
</app-formfnsimple-rectificatif>

<app-formfnsimpleannulation
	*ngIf="is(formsEnum.SIMP_AN)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue" [diffBoamp]="diffBoamp"

></app-formfnsimpleannulation>

<app-formfnsimple-attribution
	*ngIf="is(formsEnum.SIMP_AT)"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis"
	[currentJson]="currentJson"
	[form]="form"
    [formName]="formulaireName.toString()"
    [diffJoue]="diffJoue"
	[diffBoamp]="diffBoamp"

>
	</app-formfnsimple-attribution>

<app-redactionavis
	*ngIf="is(formsEnum.FORM_AD) || getServiceNavigateDiffAD() === true"
	[indexPage]="indexPage"
	[disabled]="disabled"
	[linkForRouter]="linkForRouter"
	[tableClass]="tableClass"
	[formClass]="formClass"
	[referenceAvis]="referenceAvis" [currentJson]="currentJson"
	[form]="form"
  [diffJoue]="diffJoue"
	[diffBoamp]="diffBoamp"
	[fadIndex]="fadIndex"
	[formName]="formulaireName?.toString()"
>
</app-redactionavis>

<app-eforms-component
  [indexPage]="indexPage"
  [validationIndex]="validationIndex"
  [currentJson]="currentJson"
  [formulaireName]="formulaireName"
  *ngIf="is(formsEnum.E_FORM)"
  [formGroup]="form"
  [linkForRouter]="linkForRouter">
</app-eforms-component>
